import React from 'react';

const ArrowLeft = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 7 12" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="ArrowLeft_a" d="M538 803.36l-4.35 4.47 4.35 4.48-1.32 1.36-5.68-5.84 5.68-5.83z" />
    </defs>
    <use fill="currentColor" xlinkHref="#ArrowLeft_a" transform="translate(-531 -802)" />
  </svg>
);

export default ArrowLeft;



// WEBPACK FOOTER //
// ./src/common/icons/ArrowLeft.js